import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { UpdateArrearsForm } from 'Feature/Arrears/components/ArrearsInquiryPage/ui/flyout/ArrearsFlyoutContent';
import { useTranslation } from 'react-i18next';
import { DatePickerFormField } from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/form/DatePickerFormField';
import { Arrears } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Arrears';

export const ArrearsFlyoutDueDateField = ({
  label,
  isReadOnly = true,
  form,
  arrears
}: {
  label: string;
  isReadOnly?: boolean;
  form: UseFormReturn<UpdateArrearsForm>;
  arrears: Arrears;
}) => {
  const { t } = useTranslation('HbtArrearsInquiryPage');
  const field = form.register('dueDate', {
    required: t('arrearsFlyout.errors.dueDate.required'),
    pattern: { value: /^\d{4}-\d{2}-\d{2}$/, message: t('arrearsFlyout.errors.dueDate.pattern') },
    max: { value: arrears.reportingPeriodDate, message: t('arrearsFlyout.errors.dueDate.max') },
    min:
      arrears.loanApprovalDate === undefined
        ? undefined
        : { value: arrears.loanApprovalDate, message: t('arrearsFlyout.errors.dueDate.min') }
  });

  const onValueChange = (value: Date | null) => {
    form.setValue(field.name, value?.toLocaleDateString('en-CA'), {
      shouldValidate: true
    });
  };

  return (
    <DatePickerFormField
      label={label}
      isReadOnly={isReadOnly}
      error={!!form.formState.errors.dueDate}
      errorMessage={form.formState.errors.dueDate?.message}
      value={form.getValues(field.name)}
      dateFormat={'yyyy-MM-dd'}
      onValueChange={onValueChange}
      inputRef={field.ref}
    />
  );
};
